import tinycolor from 'tinycolor2'
import ColorNames from '../locals/colorNames.json'

const ColorComponent = (props) => {

    const {color, className=''} = props;

    const getColorFromJson = () => {

        if (ColorNames[color?.toUpperCase()]) {
            return ColorNames[color?.toUpperCase()];
        }
        return null;
    }

    const getColorOrDefault = () => {
      if(getColorFromJson()) {
        return getColorFromJson();
      }
        const response = tinycolor(color);
        return response.isValid() ? response.toHexString() : null;
    };

  return (
    <div
        style={{
            backgroundColor: getColorOrDefault(),
            // boxShadow: getColorOrDefault() === 'transparent' ? '' : '0 0 2px black'
        }}
        className={`${getColorOrDefault() ? 'inline-block shrink-0 h-[11px] w-[11px] rounded-full ' : 'relative inline-flex'} ${className}`}
    >
      {!getColorOrDefault() && <>
        <div className='shrink-0 h-[11px] w-[11px] rounded-full bg-[#E5E5E5] border border-[#E5E5E5] mt-[0.5px]'></div>
        <div className='shrink-0 h-[12px] w-[12px] rounded-full bg-[#CDD9E4] border border-white absolute left-[4px]'></div>
      </>}
    </div>
  )
}

export default ColorComponent